import { EditableImg, EditableText } from '@smartfire/components';
import { defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import React from 'react';
import YouTube from 'react-youtube';
import clsx from 'clsx';
import style from './block.module.scss';

const InspectorLazy = React.lazy(() => import('./Inspector'));
function Block({ textPlus, videoUrl, toggleVideo, informations2, informations1 }) {
    const { isEditing } = useEditor();
    useInspectorControl(InspectorLazy, []);

    return (
        <div className={style.block}>
            <div className={style.content}>
                <div className={style.grid}>
                    <EditableText
                        tagName="h3"
                        className={style.title}
                        placeholder="ajouter un titre"
                        smartProp="title"
                    />
                    <div className={style.col1}>
                        <EditableText
                            tagName="p"
                            className={style.mainText}
                            placeholder="ajouter un texte"
                            smartProp="text"
                            allowedFormats={['core/bold', 'advanced/color', 'core/link']}
                        />
                        {toggleVideo ? (
                            <YouTube videoId={videoUrl} className={style.ytContainer} iframeClassName={style.yt} />
                        ) : (
                            <EditableImg smartProp="image" />
                        )}
                    </div>
                    <div className={style.col2}>
                        {(isEditing || textPlus) && (
                            <div className={style.lesPlus}>
                                <div className={style.plusTitle}>
                                    les <span className={style.plus}>+</span>
                                </div>
                                <EditableText
                                    tagName="ul"
                                    multiline="li"
                                    placeholder="ajouter un texte"
                                    smartProp="textPlus"
                                    allowedFormats={['core/bold', 'advanced/color', 'core/link']}
                                />
                            </div>
                        )}
                        <div className={style.grid}>
                            <EditableText
                                className={style.col1}
                                placeholder="ajouter des informations"
                                smartProp="informations1"
                                allowedFormats={['core/bold', 'advanced/color', 'core/link']}
                            />
                            <EditableText
                                className={clsx(style.col2, informations1 && informations2 ? style.marged : undefined)}
                                placeholder="ajouter des informations"
                                smartProp="informations2"
                                allowedFormats={['core/bold', 'advanced/color', 'core/link']}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        image: smartProps.image.withDefault(null),
        title: smartProps.string.withDefault(''),
        text: smartProps.string.withDefault(''),
        textPlus: smartProps.string.withDefault(''),
        informations1: smartProps.string.withDefault(''),
        informations2: smartProps.string.withDefault(''),
        videoUrl: smartProps.string.withDefault(''),
        toggleVideo: smartProps.bool.withDefault(false),
    },
    setup: {
        title: 'Contenu Evolved',
        icon: 'align-left',
    },
});
